// src/components/JourneyPage.js
import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
// Journey component removed - journey experience is mobile-only
// import Journey from '../Journey'; 

function JourneyPage({ journeyData: propJourneyData, journeyId: propJourneyId }) {
  const { journeyId: paramId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  // Local state for activation code (if you still want to track it)
  const [activationCode, setActivationCode] = useState('');

  // We'll store whichever journeyId we have: prop, param, or null
  const [localJourneyId, setLocalJourneyId] = useState(propJourneyId || paramId || null);
  const [localJourneyData, setLocalJourneyData] = useState(propJourneyData || null);

  // const [routeNames, setRouteNames] = useState([]);

  // If there's a code passed in location.state, store it
  useEffect(() => {
    if (location.state && location.state.code) {
      setActivationCode(location.state.code);
    }
  }, [location.state]);

  // =============== FETCH FROM BACKEND (Optional) ===============
  useEffect(() => {
    // If we don't have prop data but do have a journeyId, try fetching from your backend
    if (!propJourneyData && localJourneyId) {
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/journey/${localJourneyId}`)
        .then((res) => {
          if (!res.ok) {
            throw new Error(`Server error: ${res.statusText}`);
          }
          return res.json();
        })
        .then((data) => {
          setLocalJourneyData(data);
        })
        .catch((error) => {
          console.error('Error fetching journey data:', error);
          setLocalJourneyData(null);
        });
    }
  }, [propJourneyData, localJourneyId]);

  // If the parent props changed, update local state
  useEffect(() => {
    if (propJourneyData && propJourneyId) {
      setLocalJourneyData(propJourneyData);
      setLocalJourneyId(propJourneyId);
    }
  }, [propJourneyData, propJourneyId]);

  // Show a loading fallback if we haven't loaded journeyData yet
  if (!localJourneyId || !localJourneyData) {
    return (
      <div style={{ color: 'white', textAlign: 'center', marginTop: '50px' }}>
        <p>Loading journey details...</p>
        <button
          onClick={() => navigate('/')}
          style={{
            marginTop: '20px',
            padding: '10px 15px',
            backgroundColor: '#853a38',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
        >
          Back
        </button>
      </div>
    );
  }

  // Journey experience is mobile-only - redirect users to mobile app
  return (
    <div style={{ 
      padding: '20px', 
      textAlign: 'center', 
      marginTop: '50px',
      backgroundColor: 'rgba(255,255,255,0.9)',
      borderRadius: '10px',
      maxWidth: '600px',
      margin: '50px auto'
    }}>
      <h2 style={{ color: '#333', marginBottom: '20px' }}>Journey Management</h2>
      
      {activationCode && (
        <div style={{ 
          backgroundColor: '#f0f0f0', 
          padding: '10px', 
          borderRadius: '5px',
          marginBottom: '20px'
        }}>
          <p style={{ color: '#333', margin: '5px 0' }}>
            <strong>Your Activation Code:</strong> {activationCode}
          </p>
        </div>
      )}
      
      <p style={{ color: '#666', fontSize: '18px', marginBottom: '30px' }}>
        The journey experience is exclusively available on the BackPass mobile app.
      </p>
      
      <p style={{ color: '#666', marginBottom: '20px' }}>
        Please download the BackPass mobile app to:
      </p>
      
      <ul style={{ 
        textAlign: 'left', 
        display: 'inline-block',
        color: '#666',
        marginBottom: '30px'
      }}>
        <li>View and manage your journey details</li>
        <li>Select and book hostels for each day</li>
        <li>Track your booking status</li>
        <li>Access your travel itinerary</li>
      </ul>
      
      <div style={{ marginTop: '30px' }}>
        <button
          onClick={() => navigate('/dashboard')}
          style={{
            padding: '12px 24px',
            backgroundColor: '#FFD700',
            color: '#333',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: 'bold',
            marginRight: '10px'
          }}
        >
          Go to Dashboard
        </button>
        
        <button
          onClick={() => navigate('/')}
          style={{
            padding: '12px 24px',
            backgroundColor: '#853a38',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: 'bold'
          }}
        >
          Back to Home
        </button>
      </div>
    </div>
  );
}

export default JourneyPage;
